// Auto-generated. Do not edit manually — run: yarn generate:icons

export const enum IconType {
  _360degree = '/icons/360degree.svg',
  _360Degree = '/icons/360-degree.svg',
  A11y = '/icons/a11y.svg',
  About = '/icons/about.svg',
  ArrowGoingUp = '/icons/arrow-going-up.svg',
  BurgerMenu = '/icons/burger-menu.svg',
  Calendar = '/icons/calendar.svg',
  Checklist = '/icons/checklist.svg',
  Checkmark = '/icons/checkmark.svg',
  CheckmarkCircle = '/icons/checkmark-circle.svg',
  Clock = '/icons/clock.svg',
  Google = '/icons/google.svg',
  Group = '/icons/group.svg',
  HappyFace = '/icons/happy-face.svg',
  Home = '/icons/home.svg',
  MapPin = '/icons/map-pin.svg',
  Offers = '/icons/offers.svg',
  Phone = '/icons/phone.svg',
  Pik360Degree = '/icons/piktogramme/360-degree.svg',
  PikAcademicHat = '/icons/piktogramme/academic-hat.svg',
  PikArrow = '/icons/piktogramme/arrow.svg',
  PikBook = '/icons/piktogramme/book.svg',
  PikBrandenburgerTor = '/icons/piktogramme/brandenburger-tor.svg',
  PikCall = '/icons/piktogramme/call.svg',
  PikCandy = '/icons/piktogramme/candy.svg',
  PikChecklist = '/icons/piktogramme/checklist.svg',
  PikClock = '/icons/piktogramme/clock.svg',
  PikCompass = '/icons/piktogramme/compass.svg',
  PikConfetti = '/icons/piktogramme/confetti.svg',
  PikDislike = '/icons/piktogramme/dislike.svg',
  PikEiffelTower = '/icons/piktogramme/eiffel-tower.svg',
  PikEMail = '/icons/piktogramme/e-mail.svg',
  PikEnvironment = '/icons/piktogramme/environment.svg',
  PikFormula = '/icons/piktogramme/formula.svg',
  PikGrade = '/icons/piktogramme/grade.svg',
  PikGroup = '/icons/piktogramme/group.svg',
  PikGrowth = '/icons/piktogramme/growth.svg',
  PikHand = '/icons/piktogramme/hand.svg',
  PikKIAssistentin = '/icons/piktogramme/KI-Assistentin.svg',
  PikLanguageEnglish = '/icons/piktogramme/language_english.svg',
  PikLanguageFrench = '/icons/piktogramme/language_french.svg',
  PikLanguageGerman = '/icons/piktogramme/language_german.svg',
  PikLanguageLatein01 = '/icons/piktogramme/language_latein-01.svg',
  PikLanguageLatein02 = '/icons/piktogramme/language_latein-02.svg',
  PikLaptop = '/icons/piktogramme/laptop.svg',
  PikLightbulb = '/icons/piktogramme/lightbulb.svg',
  PikLike = '/icons/piktogramme/like.svg',
  PikLocal = '/icons/piktogramme/local.svg',
  PikLock = '/icons/piktogramme/lock.svg',
  PikLogin = '/icons/piktogramme/login.svg',
  PikMask = '/icons/piktogramme/mask.svg',
  PikMathe = '/icons/piktogramme/mathe.svg',
  PikMaths = '/icons/piktogramme/maths.svg',
  PikMolecule = '/icons/piktogramme/molecule.svg',
  PikMoney = '/icons/piktogramme/money.svg',
  PikMonitorTarget = '/icons/piktogramme/monitor-target.svg',
  PikMountainsFlag = '/icons/piktogramme/mountains-flag.svg',
  PikPaperPlane = '/icons/piktogramme/paper-plane.svg',
  PikPencilRuler = '/icons/piktogramme/pencil-ruler.svg',
  PikPisaTower = '/icons/piktogramme/pisa-tower.svg',
  PikPokal = '/icons/piktogramme/pokal.svg',
  PikQuestionAnswer = '/icons/piktogramme/question-answer.svg',
  PikQuote = '/icons/piktogramme/quote.svg',
  PikSatzDesPythagoras = '/icons/piktogramme/satz-des-pythagoras.svg',
  PikSchultueten = '/icons/piktogramme/schultueten.svg',
  PikSeal = '/icons/piktogramme/seal.svg',
  PikSettings = '/icons/piktogramme/settings.svg',
  PikShakehands = '/icons/piktogramme/shakehands.svg',
  PikShieldLock = '/icons/piktogramme/shield-lock.svg',
  PikSmiliyGut = '/icons/piktogramme/smiliy-gut.svg',
  PikSmiliyMittel = '/icons/piktogramme/smiliy-mittel.svg',
  PikSmiliySchlecht = '/icons/piktogramme/smiliy-schlecht.svg',
  PikSmiliyZwinker = '/icons/piktogramme/smiliy-zwinker.svg',
  PikSoccer = '/icons/piktogramme/soccer.svg',
  PikSodaWater = '/icons/piktogramme/soda-water.svg',
  PikStar = '/icons/piktogramme/star.svg',
  PikSubjectBiology = '/icons/piktogramme/subject-biology.svg',
  PikSubjectChemistry = '/icons/piktogramme/subject-chemistry.svg',
  PikSubjectEnglish = '/icons/piktogramme/subject-english.svg',
  PikSubjectFrench = '/icons/piktogramme/subject-french.svg',
  PikSubjectGerman = '/icons/piktogramme/subject-german.svg',
  PikSubjectLatin = '/icons/piktogramme/subject-latin.svg',
  PikSubjectPhysics = '/icons/piktogramme/subject-physics.svg',
  PikSunBeach = '/icons/piktogramme/sun-beach.svg',
  PikSunMountains = '/icons/piktogramme/sun-mountains.svg',
  PikTabletennis = '/icons/piktogramme/tabletennis.svg',
  PikTeam = '/icons/piktogramme/team.svg',
  PikTennis = '/icons/piktogramme/tennis.svg',
  PikTolerance = '/icons/piktogramme/tolerance.svg',
  PikUnionJack = '/icons/piktogramme/union-jack.svg',
  PikUserComputer = '/icons/piktogramme/user-computer.svg',
  PikVideoCall = '/icons/piktogramme/video-call.svg',
  PikVirus = '/icons/piktogramme/virus.svg',
  PikVoucher = '/icons/piktogramme/voucher.svg',
  PikWheel = '/icons/piktogramme/wheel.svg',
  PikWomanMan = '/icons/piktogramme/woman_man.svg',
  PikXmasTree = '/icons/piktogramme/xmas-tree.svg',
  PikZahnraeder = '/icons/piktogramme/zahnraeder.svg',
  PikZeugnis = '/icons/piktogramme/zeugnis.svg',
  PikZirkel = '/icons/piktogramme/zirkel.svg',
  Seal = '/icons/seal.svg',
  Star = '/icons/star.svg',
  SvgAcademicCap = '/icons/svg/academic-cap.svg',
  SvgAdd = '/icons/svg/add.svg',
  SvgArrowCircleRightFilled = '/icons/svg/arrow-circle-right-filled.svg',
  SvgArrowLeft = '/icons/svg/arrow-left.svg',
  SvgArrowRight = '/icons/svg/arrow-right.svg',
  SvgArrowRightBold = '/icons/svg/arrow-right-bold.svg',
  SvgBill = '/icons/svg/bill.svg',
  SvgBook = '/icons/svg/book.svg',
  SvgBookFinger = '/icons/svg/book-finger.svg',
  SvgBookLightBulb = '/icons/svg/book-light-bulb.svg',
  SvgBrain = '/icons/svg/brain.svg',
  SvgBrainFormula = '/icons/svg/brain-formula.svg',
  SvgBuildings = '/icons/svg/buildings.svg',
  SvgBurgerFilled = '/icons/svg/burger-filled.svg',
  SvgBurgerHolo = '/icons/svg/burger-holo.svg',
  SvgCalendar = '/icons/svg/calendar.svg',
  SvgCertificate = '/icons/svg/certificate.svg',
  SvgChartIncreasing = '/icons/svg/chart-increasing.svg',
  SvgCheckboxUnchecked = '/icons/svg/checkbox-unchecked.svg',
  SvgChecklist = '/icons/svg/checklist.svg',
  SvgCheckmark = '/icons/svg/checkmark.svg',
  SvgCheckmarkCircle = '/icons/svg/checkmark-circle.svg',
  SvgChemistry = '/icons/svg/chemistry.svg',
  SvgChevronDown = '/icons/svg/chevron-down.svg',
  SvgChevronLeft = '/icons/svg/chevron-left.svg',
  SvgChevronRight = '/icons/svg/chevron-right.svg',
  SvgChevronUp = '/icons/svg/chevron-up.svg',
  SvgClock = '/icons/svg/clock.svg',
  SvgClose = '/icons/svg/close.svg',
  SvgCoins = '/icons/svg/coins.svg',
  SvgExklamationMark = '/icons/svg/exklamation-mark.svg',
  SvgGift = '/icons/svg/gift.svg',
  SvgGirl = '/icons/svg/girl.svg',
  SvgGroup = '/icons/svg/group.svg',
  SvgGrowth = '/icons/svg/growth.svg',
  SvgHome = '/icons/svg/home.svg',
  SvgInfo = '/icons/svg/info.svg',
  SvgInfoSheet = '/icons/svg/info-sheet.svg',
  SvgJobs = '/icons/svg/jobs.svg',
  SvgLaptop = '/icons/svg/laptop.svg',
  SvgLightBulb = '/icons/svg/light-bulb.svg',
  SvgLocalBuilding = '/icons/svg/local-building.svg',
  SvgLocalPin = '/icons/svg/local-pin.svg',
  SvgLogin = '/icons/svg/login.svg',
  SvgMagicHat = '/icons/svg/magic-hat.svg',
  SvgMailFilled = '/icons/svg/mail-filled.svg',
  SvgMailHolo = '/icons/svg/mail-holo.svg',
  SvgMedal = '/icons/svg/medal.svg',
  SvgPen = '/icons/svg/pen.svg',
  SvgPercentage = '/icons/svg/percentage.svg',
  SvgPhoneFilled = '/icons/svg/phone-filled.svg',
  SvgPhoneHolo = '/icons/svg/phone-holo.svg',
  SvgPlay = '/icons/svg/play.svg',
  SvgQuestionMark = '/icons/svg/question-mark.svg',
  SvgRackWheels = '/icons/svg/rack-wheels.svg',
  SvgRadioButtonChecked = '/icons/svg/radio-button-checked.svg',
  SvgRadioButtonUnchecked = '/icons/svg/radio-button-unchecked.svg',
  SvgRefresh = '/icons/svg/refresh.svg',
  SvgSeasonalsEaster = '/icons/svg/seasonals-easter.svg',
  SvgSeasonalsNewYear = '/icons/svg/seasonals-new-year.svg',
  SvgSeasonalsXmas = '/icons/svg/seasonals-xmas.svg',
  SvgSettings = '/icons/svg/settings.svg',
  SvgShare = '/icons/svg/share.svg',
  SvgSmile = '/icons/svg/smile.svg',
  SvgSocialFacebook = '/icons/svg/social-facebook.svg',
  SvgSocialInstagram = '/icons/svg/social-instagram.svg',
  SvgSocialYoutube = '/icons/svg/social-youtube.svg',
  SvgSpeechBubble = '/icons/svg/speech-bubble.svg',
  SvgStarFilled = '/icons/svg/star-filled.svg',
  SvgStarHolo = '/icons/svg/star-holo.svg',
  SvgSubjectBiology = '/icons/svg/subject-biology.svg',
  SvgSubjectChemistry = '/icons/svg/subject-chemistry.svg',
  SvgSubjectEnglish = '/icons/svg/subject-english.svg',
  SvgSubjectFrench = '/icons/svg/subject-french.svg',
  SvgSubjectGerman = '/icons/svg/subject-german.svg',
  SvgSubjectLatin = '/icons/svg/subject-latin.svg',
  SvgSubjectMath = '/icons/svg/subject-math.svg',
  SvgSubjectPhysics = '/icons/svg/subject-physics.svg',
  SvgSubjectSpanish = '/icons/svg/subject-spanish.svg',
  SvgTeacher = '/icons/svg/teacher.svg',
  SvgThumbUp = '/icons/svg/thumb-up.svg',
  SvgUserComputer = '/icons/svg/user-computer.svg',
  SvgVideoChat = '/icons/svg/video-chat.svg',
  SvgWarning = '/icons/svg/warning.svg',
  SvgZahl0 = '/icons/svg/zahl-0.svg',
  SvgZahl1 = '/icons/svg/zahl-1.svg',
  SvgZahl10 = '/icons/svg/zahl-10.svg',
  SvgZahl11 = '/icons/svg/zahl-11.svg',
  SvgZahl11Bis12 = '/icons/svg/zahl-11-bis-12.svg',
  SvgZahl11Bis13 = '/icons/svg/zahl-11-bis-13.svg',
  SvgZahl12 = '/icons/svg/zahl-12.svg',
  SvgZahl13 = '/icons/svg/zahl-13.svg',
  SvgZahl1Bis4 = '/icons/svg/zahl-1-bis-4.svg',
  SvgZahl2 = '/icons/svg/zahl-2.svg',
  SvgZahl3 = '/icons/svg/zahl-3.svg',
  SvgZahl4 = '/icons/svg/zahl-4.svg',
  SvgZahl5 = '/icons/svg/zahl-5.svg',
  SvgZahl5Bis10 = '/icons/svg/zahl-5-bis-10.svg',
  SvgZahl6 = '/icons/svg/zahl-6.svg',
  SvgZahl7 = '/icons/svg/zahl-7.svg',
  SvgZahl8 = '/icons/svg/zahl-8.svg',
  SvgZahl9 = '/icons/svg/zahl-9.svg',
  TaskBoard = '/icons/taskBoard.svg',
  Tutors = '/icons/tutors.svg',
}

export const ICON_PATHS: Record<string, string> = {
  _360degree: '/icons/360degree.svg',
  _360Degree: '/icons/360-degree.svg',
  A11y: '/icons/a11y.svg',
  About: '/icons/about.svg',
  ArrowGoingUp: '/icons/arrow-going-up.svg',
  BurgerMenu: '/icons/burger-menu.svg',
  Calendar: '/icons/calendar.svg',
  Checklist: '/icons/checklist.svg',
  Checkmark: '/icons/checkmark.svg',
  CheckmarkCircle: '/icons/checkmark-circle.svg',
  Clock: '/icons/clock.svg',
  Google: '/icons/google.svg',
  Group: '/icons/group.svg',
  HappyFace: '/icons/happy-face.svg',
  Home: '/icons/home.svg',
  MapPin: '/icons/map-pin.svg',
  Offers: '/icons/offers.svg',
  Phone: '/icons/phone.svg',
  Pik360Degree: '/icons/piktogramme/360-degree.svg',
  PikAcademicHat: '/icons/piktogramme/academic-hat.svg',
  PikArrow: '/icons/piktogramme/arrow.svg',
  PikBook: '/icons/piktogramme/book.svg',
  PikBrandenburgerTor: '/icons/piktogramme/brandenburger-tor.svg',
  PikCall: '/icons/piktogramme/call.svg',
  PikCandy: '/icons/piktogramme/candy.svg',
  PikChecklist: '/icons/piktogramme/checklist.svg',
  PikClock: '/icons/piktogramme/clock.svg',
  PikCompass: '/icons/piktogramme/compass.svg',
  PikConfetti: '/icons/piktogramme/confetti.svg',
  PikDislike: '/icons/piktogramme/dislike.svg',
  PikEiffelTower: '/icons/piktogramme/eiffel-tower.svg',
  PikEMail: '/icons/piktogramme/e-mail.svg',
  PikEnvironment: '/icons/piktogramme/environment.svg',
  PikFormula: '/icons/piktogramme/formula.svg',
  PikGrade: '/icons/piktogramme/grade.svg',
  PikGroup: '/icons/piktogramme/group.svg',
  PikGrowth: '/icons/piktogramme/growth.svg',
  PikHand: '/icons/piktogramme/hand.svg',
  PikKIAssistentin: '/icons/piktogramme/KI-Assistentin.svg',
  PikLanguageEnglish: '/icons/piktogramme/language_english.svg',
  PikLanguageFrench: '/icons/piktogramme/language_french.svg',
  PikLanguageGerman: '/icons/piktogramme/language_german.svg',
  PikLanguageLatein01: '/icons/piktogramme/language_latein-01.svg',
  PikLanguageLatein02: '/icons/piktogramme/language_latein-02.svg',
  PikLaptop: '/icons/piktogramme/laptop.svg',
  PikLightbulb: '/icons/piktogramme/lightbulb.svg',
  PikLike: '/icons/piktogramme/like.svg',
  PikLocal: '/icons/piktogramme/local.svg',
  PikLock: '/icons/piktogramme/lock.svg',
  PikLogin: '/icons/piktogramme/login.svg',
  PikMask: '/icons/piktogramme/mask.svg',
  PikMathe: '/icons/piktogramme/mathe.svg',
  PikMaths: '/icons/piktogramme/maths.svg',
  PikMolecule: '/icons/piktogramme/molecule.svg',
  PikMoney: '/icons/piktogramme/money.svg',
  PikMonitorTarget: '/icons/piktogramme/monitor-target.svg',
  PikMountainsFlag: '/icons/piktogramme/mountains-flag.svg',
  PikPaperPlane: '/icons/piktogramme/paper-plane.svg',
  PikPencilRuler: '/icons/piktogramme/pencil-ruler.svg',
  PikPisaTower: '/icons/piktogramme/pisa-tower.svg',
  PikPokal: '/icons/piktogramme/pokal.svg',
  PikQuestionAnswer: '/icons/piktogramme/question-answer.svg',
  PikQuote: '/icons/piktogramme/quote.svg',
  PikSatzDesPythagoras: '/icons/piktogramme/satz-des-pythagoras.svg',
  PikSchultueten: '/icons/piktogramme/schultueten.svg',
  PikSeal: '/icons/piktogramme/seal.svg',
  PikSettings: '/icons/piktogramme/settings.svg',
  PikShakehands: '/icons/piktogramme/shakehands.svg',
  PikShieldLock: '/icons/piktogramme/shield-lock.svg',
  PikSmiliyGut: '/icons/piktogramme/smiliy-gut.svg',
  PikSmiliyMittel: '/icons/piktogramme/smiliy-mittel.svg',
  PikSmiliySchlecht: '/icons/piktogramme/smiliy-schlecht.svg',
  PikSmiliyZwinker: '/icons/piktogramme/smiliy-zwinker.svg',
  PikSoccer: '/icons/piktogramme/soccer.svg',
  PikSodaWater: '/icons/piktogramme/soda-water.svg',
  PikStar: '/icons/piktogramme/star.svg',
  PikSubjectBiology: '/icons/piktogramme/subject-biology.svg',
  PikSubjectChemistry: '/icons/piktogramme/subject-chemistry.svg',
  PikSubjectEnglish: '/icons/piktogramme/subject-english.svg',
  PikSubjectFrench: '/icons/piktogramme/subject-french.svg',
  PikSubjectGerman: '/icons/piktogramme/subject-german.svg',
  PikSubjectLatin: '/icons/piktogramme/subject-latin.svg',
  PikSubjectPhysics: '/icons/piktogramme/subject-physics.svg',
  PikSunBeach: '/icons/piktogramme/sun-beach.svg',
  PikSunMountains: '/icons/piktogramme/sun-mountains.svg',
  PikTabletennis: '/icons/piktogramme/tabletennis.svg',
  PikTeam: '/icons/piktogramme/team.svg',
  PikTennis: '/icons/piktogramme/tennis.svg',
  PikTolerance: '/icons/piktogramme/tolerance.svg',
  PikUnionJack: '/icons/piktogramme/union-jack.svg',
  PikUserComputer: '/icons/piktogramme/user-computer.svg',
  PikVideoCall: '/icons/piktogramme/video-call.svg',
  PikVirus: '/icons/piktogramme/virus.svg',
  PikVoucher: '/icons/piktogramme/voucher.svg',
  PikWheel: '/icons/piktogramme/wheel.svg',
  PikWomanMan: '/icons/piktogramme/woman_man.svg',
  PikXmasTree: '/icons/piktogramme/xmas-tree.svg',
  PikZahnraeder: '/icons/piktogramme/zahnraeder.svg',
  PikZeugnis: '/icons/piktogramme/zeugnis.svg',
  PikZirkel: '/icons/piktogramme/zirkel.svg',
  Seal: '/icons/seal.svg',
  Star: '/icons/star.svg',
  SvgAcademicCap: '/icons/svg/academic-cap.svg',
  SvgAdd: '/icons/svg/add.svg',
  SvgArrowCircleRightFilled: '/icons/svg/arrow-circle-right-filled.svg',
  SvgArrowLeft: '/icons/svg/arrow-left.svg',
  SvgArrowRight: '/icons/svg/arrow-right.svg',
  SvgArrowRightBold: '/icons/svg/arrow-right-bold.svg',
  SvgBill: '/icons/svg/bill.svg',
  SvgBook: '/icons/svg/book.svg',
  SvgBookFinger: '/icons/svg/book-finger.svg',
  SvgBookLightBulb: '/icons/svg/book-light-bulb.svg',
  SvgBrain: '/icons/svg/brain.svg',
  SvgBrainFormula: '/icons/svg/brain-formula.svg',
  SvgBuildings: '/icons/svg/buildings.svg',
  SvgBurgerFilled: '/icons/svg/burger-filled.svg',
  SvgBurgerHolo: '/icons/svg/burger-holo.svg',
  SvgCalendar: '/icons/svg/calendar.svg',
  SvgCertificate: '/icons/svg/certificate.svg',
  SvgChartIncreasing: '/icons/svg/chart-increasing.svg',
  SvgCheckboxUnchecked: '/icons/svg/checkbox-unchecked.svg',
  SvgChecklist: '/icons/svg/checklist.svg',
  SvgCheckmark: '/icons/svg/checkmark.svg',
  SvgCheckmarkCircle: '/icons/svg/checkmark-circle.svg',
  SvgChemistry: '/icons/svg/chemistry.svg',
  SvgChevronDown: '/icons/svg/chevron-down.svg',
  SvgChevronLeft: '/icons/svg/chevron-left.svg',
  SvgChevronRight: '/icons/svg/chevron-right.svg',
  SvgChevronUp: '/icons/svg/chevron-up.svg',
  SvgClock: '/icons/svg/clock.svg',
  SvgClose: '/icons/svg/close.svg',
  SvgCoins: '/icons/svg/coins.svg',
  SvgExklamationMark: '/icons/svg/exklamation-mark.svg',
  SvgGift: '/icons/svg/gift.svg',
  SvgGirl: '/icons/svg/girl.svg',
  SvgGroup: '/icons/svg/group.svg',
  SvgGrowth: '/icons/svg/growth.svg',
  SvgHome: '/icons/svg/home.svg',
  SvgInfo: '/icons/svg/info.svg',
  SvgInfoSheet: '/icons/svg/info-sheet.svg',
  SvgJobs: '/icons/svg/jobs.svg',
  SvgLaptop: '/icons/svg/laptop.svg',
  SvgLightBulb: '/icons/svg/light-bulb.svg',
  SvgLocalBuilding: '/icons/svg/local-building.svg',
  SvgLocalPin: '/icons/svg/local-pin.svg',
  SvgLogin: '/icons/svg/login.svg',
  SvgMagicHat: '/icons/svg/magic-hat.svg',
  SvgMailFilled: '/icons/svg/mail-filled.svg',
  SvgMailHolo: '/icons/svg/mail-holo.svg',
  SvgMedal: '/icons/svg/medal.svg',
  SvgPen: '/icons/svg/pen.svg',
  SvgPercentage: '/icons/svg/percentage.svg',
  SvgPhoneFilled: '/icons/svg/phone-filled.svg',
  SvgPhoneHolo: '/icons/svg/phone-holo.svg',
  SvgPlay: '/icons/svg/play.svg',
  SvgQuestionMark: '/icons/svg/question-mark.svg',
  SvgRackWheels: '/icons/svg/rack-wheels.svg',
  SvgRadioButtonChecked: '/icons/svg/radio-button-checked.svg',
  SvgRadioButtonUnchecked: '/icons/svg/radio-button-unchecked.svg',
  SvgRefresh: '/icons/svg/refresh.svg',
  SvgSeasonalsEaster: '/icons/svg/seasonals-easter.svg',
  SvgSeasonalsNewYear: '/icons/svg/seasonals-new-year.svg',
  SvgSeasonalsXmas: '/icons/svg/seasonals-xmas.svg',
  SvgSettings: '/icons/svg/settings.svg',
  SvgShare: '/icons/svg/share.svg',
  SvgSmile: '/icons/svg/smile.svg',
  SvgSocialFacebook: '/icons/svg/social-facebook.svg',
  SvgSocialInstagram: '/icons/svg/social-instagram.svg',
  SvgSocialYoutube: '/icons/svg/social-youtube.svg',
  SvgSpeechBubble: '/icons/svg/speech-bubble.svg',
  SvgStarFilled: '/icons/svg/star-filled.svg',
  SvgStarHolo: '/icons/svg/star-holo.svg',
  SvgSubjectBiology: '/icons/svg/subject-biology.svg',
  SvgSubjectChemistry: '/icons/svg/subject-chemistry.svg',
  SvgSubjectEnglish: '/icons/svg/subject-english.svg',
  SvgSubjectFrench: '/icons/svg/subject-french.svg',
  SvgSubjectGerman: '/icons/svg/subject-german.svg',
  SvgSubjectLatin: '/icons/svg/subject-latin.svg',
  SvgSubjectMath: '/icons/svg/subject-math.svg',
  SvgSubjectPhysics: '/icons/svg/subject-physics.svg',
  SvgSubjectSpanish: '/icons/svg/subject-spanish.svg',
  SvgTeacher: '/icons/svg/teacher.svg',
  SvgThumbUp: '/icons/svg/thumb-up.svg',
  SvgUserComputer: '/icons/svg/user-computer.svg',
  SvgVideoChat: '/icons/svg/video-chat.svg',
  SvgWarning: '/icons/svg/warning.svg',
  SvgZahl0: '/icons/svg/zahl-0.svg',
  SvgZahl1: '/icons/svg/zahl-1.svg',
  SvgZahl10: '/icons/svg/zahl-10.svg',
  SvgZahl11: '/icons/svg/zahl-11.svg',
  SvgZahl11Bis12: '/icons/svg/zahl-11-bis-12.svg',
  SvgZahl11Bis13: '/icons/svg/zahl-11-bis-13.svg',
  SvgZahl12: '/icons/svg/zahl-12.svg',
  SvgZahl13: '/icons/svg/zahl-13.svg',
  SvgZahl1Bis4: '/icons/svg/zahl-1-bis-4.svg',
  SvgZahl2: '/icons/svg/zahl-2.svg',
  SvgZahl3: '/icons/svg/zahl-3.svg',
  SvgZahl4: '/icons/svg/zahl-4.svg',
  SvgZahl5: '/icons/svg/zahl-5.svg',
  SvgZahl5Bis10: '/icons/svg/zahl-5-bis-10.svg',
  SvgZahl6: '/icons/svg/zahl-6.svg',
  SvgZahl7: '/icons/svg/zahl-7.svg',
  SvgZahl8: '/icons/svg/zahl-8.svg',
  SvgZahl9: '/icons/svg/zahl-9.svg',
  TaskBoard: '/icons/taskBoard.svg',
  Tutors: '/icons/tutors.svg',
};
